import { HardBreak as e } from "@tiptap/extension-hard-break";
//#region src/extensions/hard-break-extension/index.ts
var t = e.extend({ addAttributes() {
	return { class: {
		default: null,
		parseHTML: (e) => e.getAttribute("class"),
		renderHTML: (e) => e.class ? { class: e.class } : {}
	} };
} }), n = e.extend({ addKeyboardShortcuts() {
	return { Enter: () => this.editor.commands.setHardBreak() };
} });
//#endregion
export { t as HardBreakExtension, n as SimpleHardBreakExtension };
